/* LINE cross-sell code for the COD form (21 Oct 2026).
   The helpdesk's LINE product cards open  /discount/EL-XXXXXX?redirect=/products/<handle>?code=EL-XXXXXX
   - Shopify's /discount link already applies the code in the normal checkout.
   - The COD form doesn't use checkout, so this script also saves the code as cart attribute
     "xsell_code". Every COD form copies the cart's attributes into the order, and the COD
     Worker asks Shopify what the code is worth on those products and deducts it.
   - On the product page it asks the Worker (/xsell-quote) what the code is worth on the
     product being picked, and shows it inside the buy box: in the pillow/seat "ยอดรวม" row
     (a red "ส่วนลดพิเศษจาก LINE" line and the reduced total), or one line above the payment
     buttons on forms without that row. No pop-ups.
   Shopify decides eligibility (which products, today only, one use), so a stale or wrong
   code simply shows and gives no discount. Loaded on every page from layout/theme.liquid. */
(function () {
  'use strict';
  var KEY = 'el_xsell_code_v1';
  var RE = /^EL-[A-Z0-9]{4,8}$/;

  function root() { return (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'); }
  function endOfToday() { var d = new Date(); d.setHours(23, 59, 59, 999); return d.getTime(); }
  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (v && RE.test(v.code) && v.until > Date.now()) return v.code;
      localStorage.removeItem(KEY);
    } catch (e) { /* storage blocked: the URL code still works for this page */ }
    return '';
  }
  function save(code) {
    try { localStorage.setItem(KEY, JSON.stringify({ code: code, until: endOfToday() })); } catch (e) { /* noop */ }
  }
  function baht(n) { return '฿' + Math.round(Number(n) || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function num(str) { var n = parseFloat(String(str || '').replace(/[^0-9.]/g, '')); return isNaN(n) ? 0 : n; }

  // Shopify's /discount/<code> link drops our ?code= on its redirect, but it leaves the code in
  // its own discount_code cookie, so read that too.
  function fromCookie() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    var v = m ? decodeURIComponent(m[1]).trim().toUpperCase() : '';
    return RE.test(v) ? v : '';
  }
  var fromUrl = (new URLSearchParams(window.location.search).get('code') || '').trim().toUpperCase();
  if (!RE.test(fromUrl)) fromUrl = fromCookie();
  var code = RE.test(fromUrl) ? fromUrl : read();
  if (!code) return; // no LINE code: nothing changes on the page
  if (fromUrl === code) save(code);

  // Put it on the real cart so the COD form (which copies cart attributes into the order) carries it.
  fetch(root() + 'cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ attributes: { xsell_code: code } })
  }).catch(function () { /* best-effort */ });

  if (window.location.pathname.indexOf('/products/') === -1) return; // the rest is for product pages

  /* ---------------------------------------------------------------- price in the buy box */
  var quote = null; // { key, applied, codeAmount, after, before }
  var pending = '';

  function workerBase() {
    var c = window.PCO_REAL_PDP_CONFIG || window.PCO_VARIANT_CONFIG || window.PCO_BEDDING_CONFIG || {};
    try { return c.reserveUrl ? new URL(c.reserveUrl).origin : ''; } catch (e) { return ''; }
  }
  function currentLine() {
    var c = window.PCO_REAL_PDP_CONFIG || window.PCO_VARIANT_CONFIG || window.PCO_BEDDING_CONFIG || {};
    var rootEl = (c.rootSelector && document.querySelector(c.rootSelector)) || document.querySelector('.product-boxed-section');
    var form = (rootEl && (rootEl.querySelector('form[data-type="add-to-cart-form"]') || rootEl.querySelector('form')))
      || document.querySelector('form.pdp-atc-form')
      || (function () { var i = document.querySelector('main form input[name="id"]'); return i ? i.form : null; })();
    if (!form) return null;
    var id = form.querySelector('input[name="id"]');
    var qty = form.querySelector('input[name="quantity"]');
    var v = id && String(id.value || '').replace(/\D/g, '');
    if (!v) return null;
    return { variantId: v, quantity: Math.max(1, parseInt(qty && qty.value, 10) || 1) };
  }

  var DISCOUNT_STYLE = 'display:block;color:#C0392B;font-size:13px;font-weight:600;margin-top:3px;';
  function pct() { return quote.before > 0 ? Math.round((quote.codeAmount / quote.before) * 100) : 0; }
  function discountText() { return '🎁 โค้ด ' + code + ' ลด ' + pct() + '%'; }

  // Pillow / seat form: the discount goes inside its "ยอดรวม" row (a line under the product
  // name, and the total reduced). The form redraws that row itself, so this re-applies.
  var patching = false;
  function patchTotalRow() {
    var row = document.getElementById('pco-real-total');
    if (!row || patching) return false;
    var label = document.getElementById('pco-real-total-label');
    var tv = document.getElementById('pco-real-total-value');
    var b = tv && tv.querySelector('b');
    if (!label || !b) return true; // row exists but not drawn yet
    patching = true;
    var line = label.querySelector('[data-el-xsell]');
    if (quote && quote.applied) {
      if (!line) { line = document.createElement('span'); line.setAttribute('data-el-xsell', '1'); line.style.cssText = DISCOUNT_STYLE; label.appendChild(line); }
      if (line.textContent !== discountText()) line.textContent = discountText();
      if (tv.getAttribute('data-el-xsell') !== b.textContent) {
        var total = num(b.textContent);
        var s = tv.querySelector('s');
        if (!s) {
          s = document.createElement('s');
          s.style.cssText = 'color:#888;font-size:14px;font-weight:400;margin-right:8px;';
          tv.insertBefore(s, b);
        }
        s.textContent = baht(Math.max(num(s.textContent), total));
        b.textContent = baht(Math.max(0, total - quote.codeAmount));
        tv.setAttribute('data-el-xsell', b.textContent);
      }
    } else if (line) {
      line.remove();
    }
    patching = false;
    return true;
  }

  // Other COD forms (bedding, towels) have no total row for a single item: one compact line
  // right above "เลือกวิธีการชำระเงิน" instead.
  function patchLineAbovePayment() {
    var pay = document.getElementById('pco-real-payment');
    if (!pay) return;
    var box = document.getElementById('el-xsell-line');
    if (!box) {
      box = document.createElement('p');
      box.id = 'el-xsell-line';
      box.style.cssText = DISCOUNT_STYLE + 'font-size:14px;margin:0 0 10px;';
      var label = pay.querySelector('.pco-real-label');
      pay.insertBefore(box, label || pay.firstChild);
    }
    if (quote && quote.applied) {
      box.textContent = discountText() + ' · เหลือ ' + baht(quote.after);
      box.style.display = 'block';
    } else box.style.display = 'none';
  }

  function paint() {
    if (!patchTotalRow()) patchLineAbovePayment();
  }

  function refresh() {
    var line = currentLine();
    var base = workerBase();
    if (!line || !base) { paint(); return; }
    var key = line.variantId + 'x' + line.quantity;
    if ((quote && quote.key === key) || pending === key) { paint(); return; }
    pending = key;
    fetch(base + '/xsell-quote', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code: code, variantId: line.variantId, quantity: line.quantity })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (q) {
        if (pending === key) pending = '';
        quote = q && typeof q.codeAmount === 'number' ? { key: key, applied: !!q.applied, codeAmount: q.codeAmount, after: q.after, before: q.before } : { key: key, applied: false };
        paint();
      });
  }

  function start() {
    refresh();
    // The forms change the picked variant / tier without events we can rely on: check twice a second.
    setInterval(refresh, 500);
    // Re-apply after the form redraws its total row (watch only that row).
    var watched = null;
    setInterval(function () {
      var row = document.getElementById('pco-real-total');
      if (!row || row === watched || !window.MutationObserver) return;
      watched = row;
      new MutationObserver(function () { if (!patching) setTimeout(paint, 0); })
        .observe(row, { childList: true, subtree: true, characterData: true });
    }, 500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
